import { render } from "./UserViewRatingSelector.vue?vue&type=template&id=1ca95704"
import script from "./UserViewRatingSelector.vue?vue&type=script&lang=js"
export * from "./UserViewRatingSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__